<template>
  <v-dialog v-model="dialog" class="vb-dialog-danger" persistent max-width="320">
    <template v-slot:activator="{ props }">
      <slot v-bind="{ props }" name="activator" />
    </template>

    <v-card data-cy="dialog-deleteEmbedMediaLink-modal">
      <v-card-title class="bg-red-darken-3 d-flex justify-space-between">
        <span v-if="embedlink.params.asset === 'web'">
        {{ $t('routes.pod.menuEmbedMedia.deletePreviewDialogTitle') }}
        </span>
        <span v-else>
        {{ $t('routes.pod.menuEmbedMedia.deleteOriginDialogTitle') }}
        </span>

        <v-btn icon @click="dialog = false" :aria-label="$t('common.close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="py-1">
        {{ $t('routes.pod.menuEmbedMedia.deleteEmbedLinkDialogMessage') }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          variant="flat"
          color="red-darken-3"
          @click="deleteLink"
          data-cy="dialog-deleteEmbedMediaLink-ok"
        >
          {{ $t('common.delete') }}
        </v-btn>
        <v-btn variant="text" @click="dialog = false" data-cy="dialog-deleteEmbedMediaLink-false">
          {{ $t('common.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { useEmbedMediaStore } from '@/stores/EmbedMediaStore.js'
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';

export default {
  mixins: [DialogActionKeys],
  name: "DeleteEmbedLinkDialog",
  props: {
    embedlink: {
      type: Object,
      required: true,
    }
  },
  data: function() {
    return {
      dialog: false,
    };
  },
  methods: {
    deleteLink: async function() {
      const payload = {
        linkId: this.embedlink.id,
        podId: this.embedlink.podid
      };

      const embedMediaStore = useEmbedMediaStore();
      try {
        await embedMediaStore.deleteEmbedLink(payload);
        await embedMediaStore.refreshEmbedLinks(this.embedlink.podid);
        this.dialog = false;
      } catch (error) {
        console.error('Error deleting embed link:', error);
      }
    }
  },
}
</script>

<style>
</style>
